export default {
  free_menu_items: 'Gratis freigeschaltet',
  discount_badge: '{{value}} Rabatt',
};
